import { useLocale } from "react-admin";
// Components
import { Box, LinearProgress, Typography } from "@material-ui/core";
const themeConfig = require("../../config/index").default;
const logo =
  require(`../../assets/images/${themeConfig.companyPrimaryLogo}`).default;
/**
 * Render a view of loading
 * @returns {component} Show loader of the app
 */
export function LoaderView() {
  const localLenguage = useLocale();
  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      style={{ backgroundColor: "#fff" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gridGap={20}
      >
        <img
          src={logo}
          width={250}
          height={65}
          style={{
            objectFit: "contain",
            maxHeight: 65,
          }}
          alt="Logo"
        />
        <Typography
          variant="h2"
          color="textPrimary"
          style={{ fontWeight: "bold" }}
        >
          {localLenguage === "en" ? "Loading view ..." : "Cargando vista ..."}
        </Typography>
        <Box sx={{ width: "280px" }} marginTop={2}>
          <LinearProgress />
        </Box>
      </Box>
    </Box>
  );
}
